import { ttuTypes } from '../constants';

export const showTTUOption = (goalUID) => ({
  type: ttuTypes.SHOW_TTU,
  endpoint: `v2/user/talk_to_unacademy/show/?goal_uid=${goalUID}`,
  method: 'get'
});

export const fetchTTUQuestions = (goalUID) => ({
  type: ttuTypes.FETCH_QUESTIONS,
  endpoint: `v2/user/talk_to_unacademy/fetch_questions/?goal_uid=${goalUID}`,
  method: 'get'
});

export const postTTUResponse = (payload) => ({
  type: ttuTypes.POST_RESPONSE,
  endpoint: 'v2/user/talk_to_unacademy/post_response/',
  method: 'post',
  data: payload
});

export const hideTTUWidget = (showState) => ({
  type: ttuTypes.HIDE_TTU_WIDGET,
  showState
});

export const showTTUCurtain = (show) => ({
  type: ttuTypes.SHOW_TTU_CURTAIN,
  show
});
